// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payapt-menu-item-active {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text);
    /* margin-bottom: 12px; */
    padding-left: 24px;
    height: 40px;
    width: auto;
    align-items: center;
    border-left: 4px solid var(--primary-color);
    display: flex;
    background-color: var(--menu-item-background);
    padding-right: 10px !important;
  }
  .payapt-menu-item {
    cursor: pointer;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text);
    margin-bottom: 12px;
    padding-left: 24px;
    height: 40px;
    align-items: center;
    width: auto;
    align-items: center;
    display: flex;
    border-left: 4px solid var(--background-white);
    margin: 0 !important;
    padding-right: 10px !important;
  }
  .payapt-menu-title {
    margin-left: 15.5px;
  }
  .payapt-nested-menu-item > .payapt-menu-item-active{
    padding-left: 52px;
  }
  .payapt-nested-menu-item > .payapt-menu-item{
    padding-left: 52px !important;
  }
  .payapt-menu {
    max-width: 250px;
  }
  .payapt-collpased-menu {
    max-width: 50px;
  }
  .menu-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .menu-item-text-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .menu-item {
    /* cursor: context-menu; */
    cursor: pointer;
  }
  .payapt-menu-item-collapse {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text);
    margin-bottom: 12px;
    height: 40px;
    align-items: center;
    width: auto;
    align-items: center;
    display: flex;
    border-left: 4px solid var(--background-white);
    margin: 0 !important;
    justify-content: center;
  }
  .payapt-menu-item-collapse-active {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
    color: var(--black-text);
    /* margin-bottom: 12px; */
    height: 40px;
    width: auto;
    align-items: center;
    border-left: 4px solid var(--primary-color);
    display: flex;
    background-color: var(--menu-item-background);
    justify-content: center;
  }
  .disabled-item {
    cursor: no-drop;
  }`, "",{"version":3,"sources":["webpack://./src/shared/components/Menu/menuStyles.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,6CAA6C;IAC7C,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,8CAA8C;IAC9C,oBAAoB;IACpB,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,8CAA8C;IAC9C,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,6CAA6C;IAC7C,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB","sourcesContent":[".payapt-menu-item-active {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text);\n    /* margin-bottom: 12px; */\n    padding-left: 24px;\n    height: 40px;\n    width: auto;\n    align-items: center;\n    border-left: 4px solid var(--primary-color);\n    display: flex;\n    background-color: var(--menu-item-background);\n    padding-right: 10px !important;\n  }\n  .payapt-menu-item {\n    cursor: pointer;\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text);\n    margin-bottom: 12px;\n    padding-left: 24px;\n    height: 40px;\n    align-items: center;\n    width: auto;\n    align-items: center;\n    display: flex;\n    border-left: 4px solid var(--background-white);\n    margin: 0 !important;\n    padding-right: 10px !important;\n  }\n  .payapt-menu-title {\n    margin-left: 15.5px;\n  }\n  .payapt-nested-menu-item > .payapt-menu-item-active{\n    padding-left: 52px;\n  }\n  .payapt-nested-menu-item > .payapt-menu-item{\n    padding-left: 52px !important;\n  }\n  .payapt-menu {\n    max-width: 250px;\n  }\n  .payapt-collpased-menu {\n    max-width: 50px;\n  }\n  .menu-item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .menu-item-text-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  .menu-item {\n    /* cursor: context-menu; */\n    cursor: pointer;\n  }\n  .payapt-menu-item-collapse {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text);\n    margin-bottom: 12px;\n    height: 40px;\n    align-items: center;\n    width: auto;\n    align-items: center;\n    display: flex;\n    border-left: 4px solid var(--background-white);\n    margin: 0 !important;\n    justify-content: center;\n  }\n  .payapt-menu-item-collapse-active {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: capitalize;\n    color: var(--black-text);\n    /* margin-bottom: 12px; */\n    height: 40px;\n    width: auto;\n    align-items: center;\n    border-left: 4px solid var(--primary-color);\n    display: flex;\n    background-color: var(--menu-item-background);\n    justify-content: center;\n  }\n  .disabled-item {\n    cursor: no-drop;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
